const closeMainMenu$ = 'ui/closeMainMenu$';
const toggleMainMenu$ = 'ui/toggleMainMenu$';
const toggleSecondaryMenu$ = 'ui/toggleSecondaryMenu$';
const toggleAddressModal$ = 'ui/toggleAddressModal$';
const toggleNewAddressModal$ = 'ui/toggleNewAddressModal$';
const toggleLoadingAddresses$ = 'ui/toggleLoadingAddresses$';
const toggleCancelOrderModalOpened$ = 'ui/toggleCancelOrderModalOpened$';
const togglePaymentDataPendingModalOpened$ =
  'ui/togglePaymentDataPendingModalOpened$';
const togglePaymentDataDeniedModalOpened$ =
  'ui/togglePaymentDataDeniedModalOpened$';
const toggleModalFaqs$ = 'ui/toggleModalFaqs$';

const SET_FEEDBACK = 'ui/SET_FEEDBACK';

const ON_SCROLL_TOP = 'ui/ON_SCROLL_TOP';
const ON_SCROLL = 'ui/ON_SCROLL';

const setFormTooltip$ = 'ui/setFormTooltip$';
const clearFormTooltip$ = 'ui/clearFormTooltip$';
const CHANGE_FORM_TOOLTIPS_DATA = 'ui/CHANGE_FORM_TOOLTIPS_DATA';
const setFinishedPaymentData$ = 'ui/SET_FINISHED_PAYMENT_DATA';
const setCatalogStepName$ = 'ui/SET_CATALOG_STEP_NAME';

export default {
  closeMainMenu$,
  toggleMainMenu$,
  toggleSecondaryMenu$,
  toggleAddressModal$,
  toggleNewAddressModal$,
  toggleLoadingAddresses$,
  toggleCancelOrderModalOpened$,
  togglePaymentDataPendingModalOpened$,
  togglePaymentDataDeniedModalOpened$,
  toggleModalFaqs$,

  setFormTooltip$,
  clearFormTooltip$,

  SET_FEEDBACK,
  ON_SCROLL_TOP,
  ON_SCROLL,
  CHANGE_FORM_TOOLTIPS_DATA,
  setFinishedPaymentData$,
  setCatalogStepName$,
};
